// store/store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authSlice";
import usersReducer from "./reducers/usersReducer";
import userReducer from "./reducers/userReducer";
import userAuthReducer from "./reducers/userAuthReducer";
import groupsReducer from "./reducers/groupsReducer";
import dashsReducer from "./reducers/dashsReducer";
import imagesReducer from "./reducers/imagesReducer";
import configReducer from "./reducers/configReducer";


const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    user: userReducer,
    userAuth: userAuthReducer,
    dashs: dashsReducer,
    groups: groupsReducer,
    images: imagesReducer,
    configStore:configReducer,
  },
});

export default store;
